export default __webpack_public_path__ + "assets/images/decor.5ba084.png";